import { BasePerson, PoaItem } from '@builddocs/data-management'

import { CryptoproCertificate } from '../lib/cryptopro/types'

export const isProxyValid = (
  proxy: PoaItem | undefined,
  certificate: CryptoproCertificate | undefined,
): { isValidProxy: boolean; errorMessage?: string } => {
  if (!proxy) {
    return { isValidProxy: true }
  }

  if (proxy.status === 'invalid') {
    return {
      isValidProxy: false,
      errorMessage:
        'Невозможно подписать документ: срок действия доверенности истёк или доверенность недействительна. Выберите другую валидную доверенность и повторите попытку.',
    }
  }

  if (proxy.status === 'init') {
    return {
      isValidProxy: false,
      errorMessage:
        'Невозможно подписать документ: доверенность на проверке. Выберите другую валидную доверенность и повторите попытку.',
    }
  }

  if (!isRepresentativesDataFull(proxy.representatives)) {
    return {
      isValidProxy: false,
      errorMessage:
        'Невозможно подписать документ: в доверенности не достаточно данных. Выберите другую валидную доверенность и повторите попытку.',
    }
  }

  if (!certificate?.Subject?.CN || !certificate?.Subject?.INN) {
    return {
      isValidProxy: false,
      errorMessage:
        'Невозможно подписать документ: в сертификате не достаточно данных. Выберите другой сертификат и повторите попытку.',
    }
  }

  const { INN, CN } = certificate.Subject
  const { validUntil } = proxy

  const isRepresentativesNamesEquals = isNamesEquals(CN, proxy.representatives)
  const isRepresentativesInnsEquals = isInnEquals(INN, proxy.representatives)

  const currentDate = new Date().toISOString().split('T')[0]

  if (!isRepresentativesNamesEquals && !isRepresentativesInnsEquals) {
    return {
      isValidProxy: false,
      errorMessage:
        'Невозможно подписать документ: данные в сертификате и доверенности не совпадают.',
    }
  }

  if (currentDate > validUntil) {
    return {
      isValidProxy: false,
      errorMessage:
        'Невозможно подписать документ: срок действия доверенности истёк. Выберите другую валидную доверенность и повторите попытку.',
    }
  }

  return {
    isValidProxy: true,
  }
}

function isNamesEquals(
  cetrificateName: string,
  representatives: BasePerson[],
): boolean {
  const certificateName = cetrificateName.toLowerCase()
  const representativesNames = representatives.map((item: BasePerson) => {
    const fullName = [item?.name, item?.surname, item?.middlename]
      .filter(Boolean)
      .join(' ')
      .toLowerCase()

    return fullName
  })

  return representativesNames.some(name => name === certificateName)
}

function isInnEquals(
  certificateInn: string,
  representatives: BasePerson[],
): boolean {
  const representativesInns = representatives.map((item: BasePerson) => {
    return item?.inn ? item?.inn : '-'
  })

  return representativesInns.some(inn => inn === certificateInn)
}

function isRepresentativesDataFull(representatives: BasePerson[]): boolean {
  return representatives.every((item: BasePerson) => {
    return item?.name && item?.surname && item?.inn
  })
}
